import React from 'react'
import UserManagementPanel from '../../Component/adminComp/UserManagementPanel'


const Search = () => {
  return (
    <UserManagementPanel/>
  )
}

export default Search